import Vue from 'vue'
import Vuex from 'vuex'
import ss from '@/api/SystemService'
import system from "./utils/system";
import auth from './utils/auth'
import { setCookie, getCookie } from '@/utils/cookie'
import msg from './utils/msg'
Vue.use(Vuex)
import router from './router'
import _ from 'loadsh'
import messageService from "./api/basic/messageService";
import storage from './utils/storage'
let tabsValue = [];
if (sessionStorage.getItem("tabsValue") && auth.getToken()) {
    tabsValue = storage.getSessionTabsValue()
} else {
    tabsValue = [{
        title: '今日待办',
        path: '/',
        name: '/'
    }]
}
export default new Vuex.Store({
  state: {
      loginflag:false,
      user:{},
      menus:[],
      menulist:[],
      reslist:[],
      roles:[],
      dicts:null,
      msglist:{},
      tasktotal:0,
      checkedTotal:0,
      checked:0,
      tabsList: tabsValue,
  },
  mutations: {
      LOGOUT(state,payload){
          //设置到sesison中
          auth.removeToken();
          state.user = null;
          state.loginflag = false;
          sessionStorage.removeItem("showSalesTixing");
          router.go(0)
      },
      setUser (state, payload) {
          state.user = payload.obj;
          //设置到sesison中
          auth.setToken(state.user.tokenid)
          console.log("__work_no__",state.user)
          setCookie("__work_no__", state.user.usercode);
          state.loginflag = true
          state.menus = state.user.resTree
          state.reslist = state.user.resList
          state.roles = state.user.roles
      },
      setDict(state,payload){
          state.dicts = payload
      },
      setMsgList(state,payload){
          state.msglist = payload
      },
      setTasktotal(state,payload){
          state.tasktotal = payload
      },
      setCheckedTotal(state,payload){
          state.checkedTotal = payload
      },
      setSelectChecked(state,payload){
          state.checked = payload
      },
      addTabsValue(state, data) {
          // 判断是否已经存在
          const isExist = state.tabsList.some(item => item.path === data.path)
          // 如果不存在添加
          if (!isExist) {
              state.tabsList.push(data)
          }
      },
      removeTabsValue(state, targetPath) {
          state.tabsList = state.tabsList.filter(item => item.path !== targetPath)
      },
      resetTabsValue(state) {
          state.tabsList = [{
              title: '今日待办',
              path: '/',
              name: '/'
          }]
      },
      closeAllTabs(state) {
          state.tabsList = [{
              title: '今日待办',
              path: '/',
              name: '/'
          }]
          router.push({path: "/"})
      },
      closeOtherTabs(state,otherPath) {
          if (otherPath.path === "/" ){
              state.tabsList = [otherPath]
          }else {
              state.tabsList = [{
                  title: '今日待办',
                  path: '/',
                  name: '/'
              }, otherPath]
          }
          if (router.app._route.path === otherPath.path)
          {
              return router.push({path: otherPath.path})
          }
      }
  },
  actions: {
      async getNowUser({commit}){
          const rd =await ss.BasicService.getNowUser();
          commit("setUser",rd);
          return rd;
      },
      async getAllDictList({commit}){
          const list  = await ss.Dictservice.getAllDictList();
          commit("setDict",list);
          return list;
      },
      async searchMsgPage({commit},query){
          const list  = await ss.messageService.query(query);
          commit("setMsgList",list);
          return list;
      },
      async searchMsgTopList({commit},query){
          const list  = await ss.messageService.searchMsgTopList(query);
          commit("setMsgList",list);
          return list;
      },
      async searchCheckedTotal({commit},query){
          const r = await ss.messageService.queryCheckedTotal(query);
          commit("setCheckedTotal",r.total);
          return r.total;
      },
      async searchTasktotal({commit},query){
          const r  = await ss.taskservice.queryCount(query);
          commit("setTasktotal",r.obj);
          return r.obj;
      },
      async selectChecked({commit},query){
          const r  = await ss.messageService.selectChecked(query);
          commit("setSelectChecked",r);
          return r;
      },
      async topchecked({commit},query){
          const r  = await ss.messageService.topchecked(query);
          commit("setSelectChecked",r);
          return r;
      }


  },
    getters:{
        user: state => state.user,
        token: state => state.token,
        loginflag: state => state.loginflag,
        menus: state => state.menus,
        reslist: state => {
            return state.reslist.filter(item=> item.showflag !=1 )
        },
        rescodelist:state=>{
            return _.map(_.filter(state.reslist,item=> item.showflag !=1),"code")
        },
        menulist:state=>{
            return _.map(_.filter(state.reslist,item=> item.showflag ==1),"url")
        },
        roles: state => state.roles,
        hasRole:state=>(rolecodes)=>{
            if(_.intersection(_.map(state.roles,'id'),_.split(rolecodes,',')).length>0){
                return true;
            }
            return false;
        },
        isnbyh:state=>{
            return state.user.usertype == '0';
        },
        isdls:state=>{
            return state.user.usertype == '1';
        },
        isgys:state=>{
            return state.user.usertype == '2';
        },
        dicts: state => state.dicts,
        dictlist:state =>(c)=>{
            const d = state.dicts[c];
            return d||[];
        },
        dictname:state =>(c,v)=>{
            const d = state.dicts[c].find(r=>r.code == v);
            return d?d.name||v:v;
        },
        dictdes:state =>(c,v)=>{
            const d = state.dicts[c].find(r=>r.code == v);
            return d?d.des||v:v;
        },
        dictrefid:state =>(c,v)=>{
            const d = state.dicts[c].find(r=>r.code == v);
            return d?d.refid||v:v;
        },
        msglist:state=>state.msglist,
        tasktotal:state=>state.tasktotal,
        checkedTotal:state=>state.checkedTotal,
    }
})
